import { UAParser } from 'ua-parser-js'

/**
 * Checks if the device can install apps from Google Play Store.
 * This includes Android mobile devices and tablets, but excludes desktop/other platforms.
 */
export const isAndroidMobile = (): boolean => {
  if (globalThis.window === undefined) {
    return false
  }

  const parser = new UAParser(globalThis.window.navigator.userAgent)
  const result = parser.getResult()

  // Check if OS is Android and device is mobile or tablet (can install from Google Play Store)
  const isAndroid = result.os.name === 'Android'
  const isMobileOrTablet = result.device.type === 'mobile' || result.device.type === 'tablet'

  return isAndroid && isMobileOrTablet
}
